import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { getTidalSandboxValue } from '../atoms/tidalSandboxState.js'
import { useStoryRoute } from './useStoryRoute.js'

export function useChangeStory() {
  const { filter } = useStoryRoute()
  const navigate = useNavigate()

  return useCallback(
    (slug: string) => {
      const navigationDisabled = getTidalSandboxValue('navigationDisabled')
      if (navigationDisabled) return

      // FIXME:
      // ATTENTION: this won't work once we disable hash navigation for tidal preview
      const hash = document.location.hash
      const queryParamsIndex = hash.indexOf('?')
      const hasQueryParams = queryParamsIndex !== -1
      const queryParams = hasQueryParams ? hash.slice(queryParamsIndex) : ''

      if (filter) {
        navigate(`/${filter}/${slug}${queryParams}`)
      } else {
        navigate(`/${slug}${queryParams}`)
      }
    },
    [filter, navigate],
  )
}
